export default __webpack_public_path__ + "static/media/Montserrat-Thin.413b6b9f.ttf";